(() => {
  const SELECTORS = {
    modal: '[data-quick-add-modal]',
    form: '.quick-add__form--modal',
    step: '[data-quick-add-step]',
    panel: '[data-quick-add-product-panel]',
    variantSelect: '[data-quick-add-variant-select]',
    error: '[data-quick-add-error]',
  };

  const normalize = (value) => (value || '').trim();

  function setQuickAddButtonText(button, desktopLabel, mobileLabel) {
    const desktopText = button?.querySelector('.desktop-only');
    const mobileTextElement = button?.querySelector('.mobile-only');
    if (desktopText) desktopText.textContent = desktopLabel;
    if (mobileTextElement) mobileTextElement.textContent = mobileLabel;
    if (!desktopText && button) {
      button.textContent = desktopLabel;
    }
  }

  function setSubmitLabel(button, label) {
    const labelElement = button?.querySelector('.quick-add__submit-label');
    if (labelElement) {
      labelElement.textContent = label;
      return;
    }
    if (button) button.textContent = label;
  }

  function updateSubmitPrice(form, variant) {
    const priceWrapper = form.querySelector('.quick-add__submit-price');
    if (!priceWrapper || !variant) return;

    const price = priceWrapper.querySelector('[data-pdp-price]');
    const compareAtPrice = priceWrapper.querySelector('[data-compare-at-price]');
    if (price && variant.dataset.price) price.innerHTML = variant.dataset.price;
    if (compareAtPrice) {
      compareAtPrice.innerHTML = variant.dataset.compareAtPrice || '';
      compareAtPrice.hidden = !variant.dataset.compareAtPrice;
    }
  }

  function sortedVariantSteps(form) {
    return [...form.querySelectorAll(`${SELECTORS.step}[data-step-type="variant"]`)].sort((a, b) => {
      const orderA = parseInt(a.style.order || '4', 10);
      const orderB = parseInt(b.style.order || '4', 10);
      if (orderA !== orderB) return orderA - orderB;
      return parseInt(a.dataset.stepIndex || '0', 10) - parseInt(b.dataset.stepIndex || '0', 10);
    });
  }

  function getActivePanel(modal) {
    return modal.querySelector(`${SELECTORS.panel}.is-active`);
  }

  function getActiveForm(modal) {
    return getActivePanel(modal)?.querySelector(SELECTORS.form);
  }

  function getFormSteps(form) {
    const initialsStep = form.querySelector('[data-step-type="initials"]');
    if (initialsStep) return [initialsStep];
    return sortedVariantSteps(form);
  }

  function getFlowSteps(form) {
    const modal = form.closest(SELECTORS.modal);
    const groupStep = modal?.querySelector('[data-step-type="group"]');
    return [groupStep, ...getFormSteps(form)].filter(Boolean);
  }

  function getActiveFlowStep(form) {
    return getFlowSteps(form).find((step) => step.classList.contains('is-active'));
  }

  function isStepComplete(step) {
    if (!step) return false;
    if (step.dataset.stepType === 'initials') {
      return !!step.querySelector('.letter-id.checked, .letter-id:checked');
    }
    return step.classList.contains('is-complete');
  }

  function isFinalActiveStep(form) {
    const flowSteps = getFlowSteps(form);
    const activeStep = getActiveFlowStep(form);
    return activeStep && flowSteps.indexOf(activeStep) === flowSteps.length - 1;
  }

  function closeModal(modal) {
    const wrapper = modal.closest('.custom-modal__wrapper');
    if (!wrapper) return;
    wrapper.classList.remove('modal-show');
    document.body.classList.remove('modal-open');
  }

  function setLoading(form, isLoading) {
    const buttons = form.querySelectorAll('.pdp_add, [type="submit"]');
    form.classList.toggle('is-loading', isLoading);
    form.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    buttons.forEach((button) => {
      if (isLoading) {
        button.dataset.quickAddLoadingText = button.textContent;
        button.setAttribute('disabled', '');
      } else if (!button.classList.contains('quick-add__submit') || !button.classList.contains('d-none')) {
        button.removeAttribute('disabled');
      }
    });
  }

  function buildCartPayload(form) {
    const formData = new FormData(form);
    const itemIds = formData.getAll('items[][id]').filter(Boolean);

    if (itemIds.length) {
      const quantities = formData.getAll('items[][quantity]');
      const payload = new URLSearchParams();
      itemIds.forEach((id, index) => {
        payload.append('items[][id]', id);
        payload.append('items[][quantity]', quantities[index] || '1');
      });
      return payload;
    }

    const payload = new URLSearchParams();
    payload.append('id', formData.get('id'));
    payload.append('quantity', formData.get('quantity') || '1');
    return payload;
  }

  async function refreshAndOpenCartDrawer() {
    const drawerResponse = await fetch('/cart?view=header', {
      credentials: 'same-origin',
    });
    const drawerHtml = await drawerResponse.text();
    const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
    const incomingDrawer = parsed.querySelector('.cart-sidebar');
    const currentDrawer = document.querySelector('.cart-sidebar');

    if (incomingDrawer && currentDrawer) {
      currentDrawer.innerHTML = incomingDrawer.innerHTML;
    }

    const cartResponse = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    });
    const cart = await cartResponse.json();
    document.querySelectorAll('.cart-count').forEach((count) => {
      count.textContent = cart.item_count;
    });

    if (window.jQuery || window.$) {
      (window.jQuery || window.$)('.cart-sidebar').fadeIn();
    } else if (currentDrawer) {
      currentDrawer.style.display = 'block';
    }
    document.body.classList.add('cart-sidebar--open');
  }

  async function addQuickAddToCart(form) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: buildCartPayload(form).toString(),
    });

    if (!response.ok) {
      const text = await response.text();
      let error = null;
      try {
        error = JSON.parse(text);
      } catch (_parseError) {
        error = null;
      }
      throw new Error(error?.description || error?.message || 'Unable to add this item. Please try again.');
    }

    return response.text();
  }

  function resetForm(form) {
    form.querySelectorAll(SELECTORS.step).forEach((step) => {
      step.classList.remove('is-active', 'is-complete', 'has-error');
      step.querySelectorAll('.selected').forEach((selected) => selected.classList.remove('selected'));
      step.querySelectorAll('[name="option_value"]').forEach((input) => {
        input.value = '';
      });
      step.querySelectorAll('[data-selected-label]').forEach((label) => {
        label.textContent = '';
      });
      step.querySelectorAll('.ctm-select__label').forEach((label) => {
        const optionName = step.dataset.optionName || label.getAttribute('title') || '';
        label.textContent = optionName ? `Choose ${optionName}` : label.textContent;
      });
      step.querySelectorAll('.ctm-select__head').forEach((head) => head.classList.remove('has-selected', 'error'));
    });
    form.querySelectorAll('.quick-add-option-wrap--extra').forEach((extra) => extra.classList.add('is-hidden'));
    form.querySelectorAll('[data-quick-add-more]').forEach((button) => {
      button.hidden = false;
    });
    if (form.classList.contains('quick-add__form--initials')) {
      form.querySelectorAll('.letter-id').forEach((input) => {
        input.checked = false;
        input.classList.remove('checked');
        input.setAttribute('name', 'items[][id]');
      });
      form.querySelectorAll('.letter-qt').forEach((input) => {
        input.value = '1';
        input.removeAttribute('name');
      });
      form.querySelectorAll('.letter__count').forEach((count) => {
        count.textContent = '1';
      });
      form.querySelector('[data-step-type="initials"]')?.classList.add('is-active');
    }
    updateProgress(form);
    updateVariantState(form);
  }

  function clearFollowingSteps(form, currentStep) {
    const steps = sortedVariantSteps(form);
    const currentIndex = steps.indexOf(currentStep);
    steps.slice(currentIndex + 1).forEach((step) => {
      step.classList.remove('is-active', 'is-complete', 'has-error');
      step.querySelectorAll('.selected').forEach((selected) => selected.classList.remove('selected'));
      step.querySelectorAll('[name="option_value"]').forEach((input) => {
        input.value = '';
      });
      step.querySelectorAll('[data-selected-label]').forEach((label) => {
        label.textContent = '';
      });
      step.querySelectorAll('.ctm-select__head').forEach((head) => head.classList.remove('has-selected', 'error'));
    });
  }

  function updateProgress(form) {
    const flowSteps = getFlowSteps(form);
    if (!flowSteps.length) return;

    const currentActive = getActiveFlowStep(form);
    const nextActive = currentActive || flowSteps.find((step) => !isStepComplete(step)) || flowSteps[flowSteps.length - 1];

    flowSteps.forEach((step) => {
      step.classList.toggle('is-active', step === nextActive);
    });
  }

  function advanceStep(form) {
    const flowSteps = getFlowSteps(form);
    const activeStep = getActiveFlowStep(form);
    if (!activeStep) {
      updateProgress(form);
      return;
    }

    if (!isStepComplete(activeStep)) {
      activeStep.classList.add('has-error');
      setFormError(form, 'Please complete this option.');
      return;
    }

    const currentIndex = flowSteps.indexOf(activeStep);
    const nextStep = flowSteps[currentIndex + 1];
    if (!nextStep) return;

    activeStep.classList.remove('is-active');
    nextStep.classList.add('is-active');
    nextStep.classList.remove('has-error');
    setFormError(form, '');
    updateVariantState(form);
  }

  function initializeQuickAddModal(root) {
    const modal = root?.matches?.(SELECTORS.modal) ? root : root?.querySelector?.(SELECTORS.modal);
    if (!modal) return;

    modal.querySelectorAll(SELECTORS.form).forEach((form) => {
      resetForm(form);
    });

    const groupStep = modal.querySelector('[data-step-type="group"]');
    if (groupStep) {
      groupStep.classList.add('is-active');
    }

    const activeForm = getActiveForm(modal);
    if (activeForm) {
      updateProgress(activeForm);
      updateVariantState(activeForm);
    }
  }

  function getSelectedValues(form) {
    const selected = {};

    sortedVariantSteps(form).forEach((step) => {
      const position = step.dataset.optionPosition;
      if (!position) return;

      const dropdownValue = step.querySelector('[name="option_value"]')?.value;
      const swatchValue = step.querySelector('.swatch.selected')?.dataset.title;
      const value = normalize(dropdownValue || swatchValue);

      if (value) selected[position] = value;
    });

    return selected;
  }

  function findVariant(form, selectedValues) {
    const select = form.querySelector(SELECTORS.variantSelect);
    if (!select || select.tagName !== 'SELECT') return null;

    return [...select.options].find((option) => {
      const optionValues = (option.dataset.options || option.dataset.title || '').split('||').map(normalize);
      return Object.entries(selectedValues).every(([position, value]) => optionValues[parseInt(position, 10) - 1] === value);
    });
  }

  function setFormError(form, message) {
    const error = form.querySelector(SELECTORS.error);
    if (error) error.textContent = message || '';
  }

  function updateVariantState(form) {
    const submit = form.querySelector('.quick-add__submit');
    const soldOut = form.querySelector('.quick-add__sold-out');
    const select = form.querySelector(SELECTORS.variantSelect);
    const variantSteps = sortedVariantSteps(form);
    const selectedValues = getSelectedValues(form);
    const complete = variantSteps.every((step) => selectedValues[step.dataset.optionPosition]);
    const flowSteps = getFlowSteps(form);
    const activeStep = getActiveFlowStep(form);
    const hasMultipleSteps = flowSteps.length > 1;
    const isFinalStep = !hasMultipleSteps || isFinalActiveStep(form);

    setFormError(form, '');
    if (submit) {
      setSubmitLabel(submit, isFinalStep ? 'Add to Cart' : 'Next');
      const submitPrice = submit.querySelector('.quick-add__submit-price');
      if (submitPrice) submitPrice.hidden = !isFinalStep;
      submit.type = isFinalStep ? 'submit' : 'button';
    }

    if (form.classList.contains('quick-add__form--initials')) {
      const hasInitialSelection = !!form.querySelector('.letter-id.checked, .letter-id:checked');
      if (hasInitialSelection || (!isFinalStep && isStepComplete(activeStep))) {
        submit?.removeAttribute('disabled');
      } else {
        submit?.setAttribute('disabled', '');
      }
      return;
    }

    if (!select || select.tagName !== 'SELECT') {
      if (submit) {
        if (activeStep && !isStepComplete(activeStep)) {
          submit.setAttribute('disabled', '');
        } else {
          submit.removeAttribute('disabled');
        }
      }
      return;
    }

    if (!isFinalStep) {
      if (submit) {
        if (isStepComplete(activeStep)) {
          submit.removeAttribute('disabled');
        } else {
          submit.setAttribute('disabled', '');
        }
        submit.classList.remove('d-none');
      }
      if (soldOut) soldOut.classList.add('d-none');
      return;
    }

    if (!complete) {
      if (submit) submit.setAttribute('disabled', '');
      if (soldOut) soldOut.classList.add('d-none');
      return;
    }

    const variant = findVariant(form, selectedValues);
    if (!variant) {
      if (submit) submit.setAttribute('disabled', '');
      setFormError(form, 'This combination is unavailable.');
      return;
    }

    select.value = variant.value;
    updateSubmitPrice(form, variant);

    if (variant.dataset.available === 'true') {
      if (submit) {
        submit.classList.remove('d-none');
        submit.removeAttribute('disabled');
      }
      if (soldOut) soldOut.classList.add('d-none');
    } else {
      if (submit) {
        submit.classList.add('d-none');
        submit.setAttribute('disabled', '');
      }
      if (soldOut) {
        soldOut.classList.remove('d-none');
        soldOut.dataset.variantId = variant.value;
      }
    }
  }

  function completeStep(step, label) {
    step.classList.add('is-complete');
    step.classList.remove('has-error');
    const selectedLabel = step.querySelector('[data-selected-label]');
    if (selectedLabel) selectedLabel.textContent = label;
  }

  function selectGroupOption(button) {
    const modal = button.closest(SELECTORS.modal);
    const groupStep = button.closest(SELECTORS.step);
    const handle = button.dataset.productHandle;

    groupStep.querySelectorAll('[data-quick-add-group-option]').forEach((option) => option.classList.remove('selected'));
    button.classList.add('selected');
    completeStep(groupStep, button.dataset.title || button.textContent.trim());

    modal.querySelectorAll(SELECTORS.panel).forEach((panel) => {
      const active = panel.dataset.productHandle === handle;
      panel.classList.toggle('is-active', active);
      if (active) {
        resetForm(panel.querySelector(SELECTORS.form));
      }
    });
  }

  function selectDropdownOption(item) {
    const step = item.closest(SELECTORS.step);
    const form = item.closest(SELECTORS.form);
    const select = item.closest('.ctm-select');
    const label = item.querySelector('.ctm-select__option')?.textContent.trim() || item.getAttribute('value') || '';

    select.querySelectorAll('.variant-list__item').forEach((option) => option.classList.remove('selected'));
    item.classList.add('selected');
    select.classList.remove('ctm-select-open');
    select.querySelector('.ctm-select__body').style.display = 'none';
    select.querySelector('.ctm-select__input').value = label;
    select.querySelector('.ctm-select__label').textContent = label;
    select.querySelector('.ctm-select__head')?.classList.add('has-selected');

    const color = item.dataset.color;
    const colorNode = select.querySelector('.ctm-select__head .color');
    if (color && colorNode) colorNode.style.backgroundColor = color;

    clearFollowingSteps(form, step);
    completeStep(step, label);
    updateVariantState(form);
  }

  function selectSwatch(swatch) {
    const step = swatch.closest(SELECTORS.step);
    const form = swatch.closest(SELECTORS.form);
    const label = swatch.dataset.title || swatch.textContent.trim();

    step.querySelectorAll('.swatch').forEach((option) => option.classList.remove('selected'));
    swatch.classList.add('selected');

    clearFollowingSteps(form, step);
    completeStep(step, label);
    updateVariantState(form);
  }

  function toggleDropdown(head) {
    const current = head.closest('.ctm-select');
    const modal = head.closest(SELECTORS.modal);

    modal.querySelectorAll('.ctm-select').forEach((select) => {
      const body = select.querySelector('.ctm-select__body');
      const isCurrent = select === current;
      const isOpen = isCurrent && !select.classList.contains('ctm-select-open');
      select.classList.toggle('ctm-select-open', isOpen);
      if (body) body.style.display = isOpen ? 'block' : 'none';
    });
  }

  function updateCardImage(container, selector, src, srcset) {
    const image = container.querySelector(`${selector} img`);
    const source = container.querySelector(`${selector} source`);
    if (!image || !src) return;

    image.src = src;
    if (srcset) {
      image.srcset = srcset;
    }
    if (source && srcset) {
      source.srcset = srcset;
    }
  }

  function updateCardTitle(card, mainTitle, subTitle) {
    const title = card.querySelector('.card__desc');
    if (!title || !mainTitle) return;

    title.textContent = '';
    title.append(document.createTextNode(mainTitle));

    if (subTitle) {
      title.append(document.createTextNode(' '));
      const subtitle = document.createElement('small');
      subtitle.className = 'card__desc-sub';
      subtitle.textContent = subTitle;
      title.append(subtitle);
    }
  }

  function updateCardPrice(card, priceHtml) {
    const price = card.querySelector('.card__price');
    if (!price || !priceHtml) return;

    price.outerHTML = priceHtml;
  }

  function updateCardBadges(card, badgeHtml) {
    const currentBadges = card.querySelector('.badges__container');
    if (!badgeHtml) {
      currentBadges?.remove();
      return;
    }

    const parsed = new DOMParser().parseFromString(badgeHtml, 'text/html');
    const incomingBadges = parsed.querySelector('.badges__container');
    if (!incomingBadges) {
      currentBadges?.remove();
      return;
    }

    if (currentBadges) {
      currentBadges.replaceWith(incomingBadges);
      return;
    }

    card.querySelector('.card__img-link')?.append(incomingBadges);
  }

  function updateCardQuickAdd(card, variantId, available) {
    const directForm = card.querySelector('.quick-add__form--direct');
    const variantInput = directForm?.querySelector('[name="id"]');
    const button = directForm?.querySelector('.quick-add__button');
    if (!directForm || !variantInput || !variantId) return;

    variantInput.value = variantId;
    if (!button) return;

    if (available === 'false') {
      button.setAttribute('disabled', '');
      button.classList.add('quick-add__button--sold-out');
      setQuickAddButtonText(button, 'Sold Out', '+');
    } else {
      button.removeAttribute('disabled');
      button.classList.remove('quick-add__button--sold-out');
      setQuickAddButtonText(button, button.dataset.desktopAddLabel || 'Add to Cart', '+');
    }
  }

  function selectCardSwatch(button) {
    const swatches = button.closest('[data-card-swatches]');
    const card = button.closest('.card');
    if (!swatches || !card) return;

    swatches.querySelectorAll('[data-card-swatch]').forEach((swatch) => {
      swatch.classList.remove('selected');
    });
    button.classList.add('selected');

    updateCardImage(card, '.card__img--primary', button.dataset.primarySrc, button.dataset.primarySrcset);
    updateCardImage(card, '.card__img--secondary', button.dataset.secondarySrc, button.dataset.secondarySrcset);
    updateCardTitle(card, button.dataset.titleMain, button.dataset.titleSub);
    updateCardPrice(card, button.dataset.priceHtml);
    updateCardBadges(card, button.dataset.badgeHtml);
    updateCardQuickAdd(card, button.dataset.variantId, button.dataset.available);

    if (button.dataset.url) {
      card.querySelectorAll('.card__img-link, .card__desc').forEach((link) => {
        link.setAttribute('href', button.dataset.url);
      });
    }
  }

  document.addEventListener('click', (event) => {
    const cardSwatch = event.target.closest('[data-card-swatch]');
    if (cardSwatch) {
      event.preventDefault();
      selectCardSwatch(cardSwatch);
      return;
    }

    const groupOption = event.target.closest('[data-quick-add-group-option]');
    if (groupOption) {
      event.preventDefault();
      event.stopImmediatePropagation();
      selectGroupOption(groupOption);
      return;
    }

    const moreButton = event.target.closest('[data-quick-add-more]');
    if (moreButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const options = moreButton.closest('.quick-add-options');
      options.querySelectorAll('.quick-add-option-wrap--extra').forEach((extra) => extra.classList.remove('is-hidden'));
      moreButton.hidden = true;
      return;
    }

    const dropdownHead = event.target.closest(`${SELECTORS.modal} .ctm-select__head`);
    if (dropdownHead) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toggleDropdown(dropdownHead);
      return;
    }

    const dropdownItem = event.target.closest(`${SELECTORS.modal} .ctm-select .variant-list__item`);
    if (dropdownItem) {
      event.preventDefault();
      event.stopImmediatePropagation();
      selectDropdownOption(dropdownItem);
      return;
    }

    const swatch = event.target.closest(`${SELECTORS.modal} .swatch`);
    if (swatch) {
      event.preventDefault();
      event.stopImmediatePropagation();
      selectSwatch(swatch);
      return;
    }

    const initialControl = event.target.closest(`${SELECTORS.modal} .letter-id, ${SELECTORS.modal} .letter__remove`);
    if (initialControl) {
      const form = initialControl.closest(SELECTORS.form);
      window.setTimeout(() => updateVariantState(form), 0);
    }

    const modalTrigger = event.target.closest('modal-button > button[target]');
    if (modalTrigger) {
      window.setTimeout(() => {
        initializeQuickAddModal(document.getElementById(modalTrigger.getAttribute('target')));
      }, 0);
    }
  }, true);

  document.addEventListener('click', (event) => {
    const stepButton = event.target.closest(`${SELECTORS.modal} .quick-add__submit`);
    if (!stepButton || stepButton.type !== 'button') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const form = stepButton.closest(SELECTORS.form);
    if (form) advanceStep(form);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.quick-add__form');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const modal = form.closest(SELECTORS.modal);
    const activeForm = modal ? getActiveForm(modal) : form;
    if (modal && activeForm !== form) {
      return;
    }

    if (modal) {
      updateVariantState(form);
      const submit = form.querySelector('.quick-add__submit');
      if (submit?.hasAttribute('disabled')) {
        const firstIncomplete = getFlowSteps(form).find((step) => !isStepComplete(step));
        firstIncomplete?.classList.add('has-error');
        setFormError(form, 'Please complete the available options.');
        return;
      }
    }

    setLoading(form, true);
    setFormError(form, '');

    addQuickAddToCart(form)
      .then(() => {
        setLoading(form, false);
        if (modal) closeModal(modal);
        return refreshAndOpenCartDrawer();
      })
      .catch((error) => {
        setLoading(form, false);
        setFormError(form, error.message);
      });
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SELECTORS.modal).forEach((modal) => {
      initializeQuickAddModal(modal);
    });
  });
})();
